<template>
  <div class="home home-container" ref="home" :class="{current:!loading}">
    <div class="left-area area" :class="{active:leftActive}" @click="openLeft">


      <div class="pencil-box" :class="{active:leftActive||rightActive }">
        <canvas class="canvas"></canvas>
        <img :src="resources['homePencil'].src" class="pencil"/>
        <img :src="resources['homePencilIcon'].src " class="pencil-icon"/>
      </div>

      <div class="left-content">
        <div class="icon-plus"></div>
        <div class="row1">
          <span v-for="l in '致力于做客户'" :key="l.index">{{l}}</span>
        </div>
        <div class="row2">更有价值的战略合作伙伴 </div>
        <div class="row3">Committed to do more valuable customer strategic partners</div>
        <div class="line-box">
          <div class="line1"></div>
          <div class="line2"></div>
          <div class="line3"></div>
        </div>
      
      </div>
      

    </div>
    <div class="right-area area" :class="{active:rightActive}" @click="openRight">
      <div class="right-content light">
        <div class="icon-plus"></div>
        <div class="line1"></div>
        <div class="row-group">
          <div class="row1 row">客户利益第一</div>
          <div class="row2 row">崇尚简单</div>
          <div class="row3 row">快速响应</div>
          <div class="row4 row">相信专业的力量</div>
          <div class="row5 row">人才才是最大的资产</div>
          <div class="row6 row">拥抱互联网化</div>
        </div>
      </div>
    </div>
    <div class="footer" >
      <a href="http://www.miitbeian.gov.cn">苏ICP备15021243号</a>
    </div>
  </div>
</template>

<script>
import CanvasFrame  from "../libs/CanvasFrame.js";

export default {
  data(){
    return {
      leftActive:false,
      rightActive:false,
      resources:null,
      loading : true
    }
  },
  name: 'Home',
  created(){
    this.resources = this.$store.state.resources;
  },
  mounted() {
    this.$nextTick(()=>{
      this.f = new CanvasFrame({
        canvas:this.$refs.home.querySelector('.canvas'),
        width:736,
        height:1042,
        loop:true,
        frameRate:30,
        res:[
          {
            id:"pencilSprite",
            image: this.resources['pencilSprite'].image,
            width:324,
            height:1042,
            x: 251 ,
            y: 0,
            curIndex:0,
            callback:()=>{
              this.loading = false;
            }
          },
          {
            id:"logoSprite",
            image: this.resources['logoSprite'].image,
            width:736,
            height:280,
            x: 0 ,
            y: 253,
            curIndex:0,
            callback:()=>{
              this.f.pause();
             
            }
          }
        ]
      });
      this.f.play();

      
    })
  },
  methods:{
    openLeft(){
      this.leftActive = true;
      this.rightActive = false;
    },
    openRight(){
      this.leftActive = false;
      this.rightActive = true;
    }
  },
  beforeRouteLeave (to, from, next) {
    // ...
    this.loading = true;
    this.f.stop();
    next();
  }
}
</script>
<style lang="scss" scoped>
  @import "../common/common.scss";
  @import "../common/theme.scss";
  $duration:.4s;
  .home {
    display: flex;
    width: 100%;
    height: 100%;
  }
  .home-container.current {
    .pencil,
    .pencil-icon {
      animation: fadeIn 1s linear forwards;
    }
    canvas {
      animation: fadeOut 1s linear forwards;
    }
  }
  @keyframes fadeIn {
    0%{
      opacity: 0;
    }
    100%{
      opacity: 1;
    }
  }
  @keyframes fadeOut {
    0%{
      opacity: 1;
    }
    100%{
      opacity: 0;
    }
  }
  .area {
    position: relative;
    flex: 1;
    height: 100%;
    cursor: pointer;
    transition: all .4s linear;
    

    &.active{
      flex: 1.4;
    }
  }
  .pencil-box {
    
    position: absolute;
    height:  px2percent(648,675);
    bottom: 0;
    right: 0;
    transform: translate3d(50%,0,0) scale(.8);
    transform-origin: center bottom;
    z-index: 2;
    pointer-events: none;
    &.active {
      transform: translate3d(50%,0,0) scale(1);
      transition: all $duration linear;
    }
    .pencil{
      height: 100%;
      opacity: 0;
    }
    .pencil-icon {
      position: absolute;
      opacity: 0;
      width: px2percent(736,320);
      left: px2percent(-251,320);
      top: px2percent(253,1042);
    }

    .canvas {
      position: absolute;
      width: px2percent(736,320);
      left: px2percent(-251,320);
      top:0;
      height: 100%;
    }


  }
  
  .left-area {
    background-color: $themeColor;
  }
  .right-area {
    background-color: #eeeeee;
    padding: px2percent(380,1920) 0 0 0 ;
  }
  .left-content {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto 0 ; 
    width: 511px;
    height: 127px;
    color: #fff;
    line-height: 1;
    left: px2percent(100,1920/2);
    .icon-plus {
      transform: scale(0);
    }
    .row1,
    .row2 {
      font-size: 36px;
      height: 36px;
      overflow: hidden;
      
    }
    .row1 {
      margin-bottom: 10px;
      span {
        display: inline-block;
        transform: translate3d(0,100%,0);
      }
    }
    .row2  {
      transform: translate3d(10%,0,0);
      opacity: 0;
    }
    .row3 {
      font-size: 18px;
      margin-top: 18px;
      transform: translate3d(-10%,0,0);
      opacity: 0;
    }
    
  }
  .line-box {
    position: absolute;
    width: 100%;
    height: 110px;
    overflow: hidden;
    left: 0;
    top: 20px;
    .line1 {
      position: absolute;
      width: 60%;
      height: 1px;
      background: #fff;
      left: 0;
      top: 0;
      transform-origin: left center;
      transform: translate3d(-100%,0,0);
    }
    .line2 {
      position: absolute;
      width: 1px;
      height: 110px;
      background: #fff;
      top: 0px;
      right: 0;
      transform-origin: left center;
      transform: translate3d(0,-100%,0);
    }
    .line3 {
      position: absolute;
      width: 100%;
      height: 1px;
      background: #fff;
      left: 0;
      bottom: 0;
      transform: translate3d(100%,0,0);
    }
  }
  .left-area.active {
    .line1 {
      transform: translate3d(511px,0,0);
      transition: all 1.4s $duration linear;
    }
    .line2 {
      animation: line2_anim 1s 0.8s + $duration linear forwards;
      @keyframes line2_anim {
        0%{
          transform: translate3d(0,-100%,0);
        }
        25%,
        75%{
          transform: none;
        }
        100%{
          transform: translate3d(0,100%,0);
        }
      }
    }
    .line3 {
      transform: none;
      transition: all.8s 1s + $duration linear;
    }
    $delay : .7s + $duration;
    .row1 {
      @for $v from 1 to 7 {
        span:nth-child(#{$v}){
          transition: all 0.4s (.1s * $v ) + $delay linear;
          transform: none ;
        }
      }
    }
    .row2,
    .row3 {
      transform: none;
      opacity: 1;
      transition: all 0.8s .8s + $delay linear;
    }
    .icon-plus {
      animation: icon_anim .9s 2 * $duration linear forwards;
    }
  }
  @keyframes icon_anim {
    0%{
      transform: rotateZ(0deg) scale(0) ;
    }
    50%{
      transform: rotateZ(360deg + 21.4deg) scale(1) ;
      
    }
    75%{
      transform: rotateZ(360deg -7.7deg) scale(1) ;
    }
    100%{
      transform: rotateZ(360deg) scale(1) ;
    }
  }
  .right-content {
    height: 100%;
    position: absolute;
    right: px2percent(134,1920/2);
    width: 238px;
    padding-left: 24px;
    font-size: 24px;
    color: #424242;
    line-height: 1;
    
    .row {
      transform: translate3d(20%,0,0);
      opacity: 0;
      + .row{
        margin-top: 38px;
      }
    } 
    .icon-plus {
      top: 12px;
      left: -1px;
      transform: scale(0);
      &:after,
      &:before {
        background-color: $themeColor;
      }
    }
    .line1 {
      position: absolute;
      top: 0;
      bottom: 0;
      margin: auto;
      margin-top: 28px;
      width: 1px;
      background-color: $themeColor;
      left: 0;
      transform: scaleY(0);
      transform-origin: top center;
    }
  }
  .right-area.active {
    .icon-plus {
      animation: icon_anim .9s $duration linear forwards;
    }
    .line1 {
      transform: scaleY(1);
      transition: all 1.5s $duration + .1s linear;
    }
    @for $v from 1 to 7 {
      .row:nth-child(#{$v}){
        transition: all 0.8s ( .2s * $v ) + $duration + .4s linear;
        transform: none ;
        opacity: 1;
      }
    }

  }
  .icon-plus{
    position: absolute;
    width: 0;
    height: 0;
    left: -20px;
    top: 20px;
    &:after,
    &:before{
      content: "";
      position: absolute;
      background: #fff;
    }
    &:after {
      width: 3px;
      height: 19px;
      top: -8px;
    }
    &:before {
      width: 19px;
      height: 3px;
      left: -8px;
    }
  }
  .footer {
    position: fixed;
    right: 10px;
    bottom: 10px;
    color: #9b9b9b;
    font-size: 12px;
  }
</style>

